<template>
  <div id="wrap" class="width-100 ">
    <div id="main" :style="{ top: nowTop + 'px' }">
      <div id="page1" class="page position-relative" :style="note">
        <div>
          <heard></heard>
        </div>
        <div>
          <img src="../assets/img/gg.png" />
        </div>
        <div class="home-query-margin">
          <div class="paddings-ms back-color-white">
            <el-row :gutter="24" style="display: flex; align-items: center">
              <el-col :span="15" :offset="1" class="margin-bottom-l">
                <el-row class="margin-top-l">
                  <el-col :span="24">
                    <div>
                      <textarea
                        @focus="textareaFocus"
                        @blur="textareaBlur"
                        class="width-100"
                        :style="{ height: height + 'px' }"
                        placeholder="请输入您的运单号进行查询,多个以换行区分"
                        v-model="input1"
                      ></textarea>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="margin-top-l">
                      <el-button
                        class="text-white width-100"
                        type="primary"
                        @click="logins(input1)"
                        >运单查询
                      </el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="7">
                <el-row>
                  <el-col :span="20" :offset="2">
                    <div>
                      <img src="../assets/img/ewm.png" class="width-100" />
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="minp">
                      <p>扫一扫</p>
                      <p>运单轨迹全知道</p>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div id="page2" class="page">
        <!-- 文字导航 -->
        <div class="width-100">
          <div class="flex-all-center">
            <div class="table-spot-img">
              <img src="../assets/img/title-line.png" />
            </div>
            <div class="flex-all-center home-tatle">
              <p>云航迹</p>
              <p class="text-orange">节点获取</p>
              <p>特色</p>
            </div>
            <div class="table-spot-img">
              <img src="../assets/img/title-line.png" />
            </div>
          </div>
          <div class="flex-all-center">
            <p class="home-tatles">
              全程实时提供可视化 航班/卡运/尾程快递 重要时间节点数据
            </p>
          </div>
        </div>
        <!-- 状态显示 -->
        <div class="flex-all-center margin-top-l">
          <div class="node-text-div">
            <img src="../assets/img/pic1.png" />
            <p class="node-text-div-text">运单管理</p>
            <div class="node-solid"></div>
            <p class="node-text-div-texts">根据运单管理</p>
            <p class="node-text-div-texts">关联整个运单轨迹</p>
          </div>
          <div class="node-text-div2">
            <img src="../assets/img/pic2.png" />
            <p class="node-text-div-text">航班轨迹</p>
            <div class="node-solid"></div>
            <p class="node-text-div-texts">根据航班号及计划时间</p>
            <p class="node-text-div-texts">获取航班实时飞行轨迹</p>
          </div>
          <div class="node-text-div">
            <img src="../assets/img/pic3.png" />
            <p class="node-text-div-text">地面卡运</p>
            <div class="node-solid"></div>
            <p class="node-text-div-texts">北斗实时获取货运轨迹</p>
            <p class="node-text-div-texts">货车司机在线接单</p>
          </div>
          <div class="node-text-div2">
            <img src="../assets/img/pic4.png" />
            <p class="node-text-div-text">国外快递</p>
            <div class="node-solid"></div>
            <p class="node-text-div-texts">国外快递信息揽收节点</p>
            <p class="node-text-div-texts">送到达节点</p>
          </div>
        </div>
        <!-- 数据显示 -->
        <div class="flex-all-center back-color-db node-margin">
          <div>
            <img src="../assets/img/number1.png" />
            <p class="node-number-margin-text-min">每月航班调取轨迹数</p>
            <p class="node-number-margin-text-pro">90000+</p>
          </div>
          <div class="node-lines">
            <img src="../assets/img/number-line.png" class="node-line" />
          </div>
          <div>
            <img src="../assets/img/number2.png" />
            <p class="node-number-margin-text-min">卡运信息轨迹调取数</p>
            <p class="node-number-margin-text-pro">36000+</p>
          </div>
          <div class="node-lines">
            <img src="../assets/img/number-line.png" class="node-line" />
          </div>
          <div>
            <img src="../assets/img/number3.png" />
            <p class="node-number-margin-text-min">运单轨迹查询数</p>
            <p class="node-number-margin-text-pro">65000+</p>
          </div>
          <div class="node-lines">
            <img src="../assets/img/number-line.png" class="node-line" />
          </div>
          <div>
            <img src="../assets/img/number4.png" />
            <p class="node-number-margin-text-min">平台使用客户数</p>
            <p class="node-number-margin-text-pro">700+</p>
          </div>
        </div>
      </div>
      <div id="page3" class="page">
        <!-- 文字导航 -->
        <div class="width-100">
          <div class="flex-all-center">
            <div class="table-spot-img">
              <img src="../assets/img/title-line.png" />
            </div>
            <div class="flex-all-center home-tatle">
              <p>云航迹</p>
              <p class="text-orange">全程可视化</p>
              <p>服务</p>
            </div>
            <div class="table-spot-img">
              <img src="../assets/img/title-line.png" />
            </div>
          </div>
          <div class="flex-all-center">
            <p class="home-tatles">
              全程实时提供可视化 航班/卡运/尾程快递 运单追踪一目了然
            </p>
          </div>
        </div>
        <div>
          <img src="../assets/img/web.jpg" class="service-img" />
        </div>
      </div>

      <div id="page4" class="page" >
        <!-- 文字导航 -->
        <div class="width-100">
          <div class="flex-all-center">
            <div class="table-spot-img">
              <img src="../assets/img/title-line.png" />
            </div>
            <div class="flex-all-center home-tatle">
              <p>云航迹</p>
              <p class="text-orange">应用程序API</p>
              <p>接口</p>
            </div>
            <div class="table-spot-img">
              <img src="../assets/img/title-line.png" />
            </div>
          </div>
          <div class="flex-all-center">
            <p class="home-tatles">
              统一规范数据接口 对接推送数据 低成本云端存储 简单 全面 可靠
            </p>
          </div>
          <div class="flex-all-center leftp margin-top-l">
            <div class="margin-left-ls width-50 margin-right-l">
              <div>
                <div class="flex-alcenter">
                  <img src="../assets/img/alarm.png" />
                  <p class="home-api-text">应用程序接口API，为您提高效率</p>
                </div>
                <div class="leftp text-silver">
                  <p class="home-api-texts" >
                    提供统规范的数据接口，对接为您推送的数据，及时获取运单轨迹并实时生成轨迹图供您查阅
                  </p>
                </div>
              </div>
              <div class="margin-top-ls">
                <div class="flex-alcenter">
                  <img src="../assets/img/reliable-secure.png" />
                  <p class="home-api-text">云端大数据存储</p>
                </div>
                <div class="leftp text-silver">
                  <p class="home-api-texts">
                    安全稳定、海量、便捷、低延迟、低成本的云端存储服务、随着业务需求的变化、您可以实时扩展火缩减存储资源
                    ，满足您海量大数据存储与分析业务需求
                  </p>
                </div>
              </div>

              <div class="margin-top-ls">
                <div class="flex-alcenter">
                  <img src="../assets/img/eclipse.png" />
                  <p class="home-api-text">简单、全面、可靠</p>
                </div>
                <div class="leftp text-silver">
                  <p class="home-api-texts">
                    无需复杂操作，货代覆盖世界60多个城市、3000万海量代理API供应代理服务器独享带宽、多平台自动切换IP、免费试用10分钟。
                  </p>
                </div>
              </div>
              <div class="margin-top-ls">
                <el-button class=" width-30" type="primary">
                  点击进入API调用
                </el-button>
              </div>
            </div>

            <div style="margin-right:1.2239583333333333rem">
              <img src="../assets/img/code-pic.png" class="img-100" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script scoped>
import "@/assets/css/home.css";
import "@/assets/css/public.css";
import heard from "./public/heard.vue";
export default {
  name: "Home",
  components: {
    heard,
  },
  data() {
    return {
      height: "40",
      input1: "",
      screenWeight: 0, // 屏幕宽度
      screenHeight: 0, // 屏幕高度
      index: 1, // 用于判断翻页
      curIndex: 1, // 当前页的index
      startTime: 0, // 翻屏起始时间
      endTime: 0, // 上一次翻屏结束时间
      nowTop: 0, // 翻屏后top的位置
      pageNum: 0, // 一共有多少页
      main: Object,
      obj: Object,
      note: {
        backgroundImage:
          "url(" + require("./../assets/img/home-back.jpg") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
      },
    };
  },

  // 写入事件
  mounted() {
    this.screenWeight = document.documentElement.clientWidth;
    this.screenHeight = document.documentElement.clientHeight;
    console.log( this.screenHeight,778)
    this.main = document.getElementById("main");
    this.obj = document.getElementsByTagName("div");
    this.div1 = document.getElementById("page1");
    this.div1.style.height = this.screenHeight + "px";
    this.main.style.maxHeight = this.screenHeight +'px'
    for (let i = 0; i < this.obj.length; i++) {
      if (this.obj[i].className == "page") {
        this.obj[i].style.height = this.screenHeight + "px";
      }
    }
    this.pageNum = document.querySelectorAll(".page").length;

    // 浏览器兼容
    if (navigator.userAgent.toLowerCase().indexOf("firefox") != -1) {
      console.log("在火狐浏览器");
      document.addEventListener("DOMMouseScroll", this.scrollFun, false);
    } else if (document.addEventListener) {
      console.log("在chrome浏览器");
      document.addEventListener("mousewheel", this.scrollFun, false);
    } else if (document.attachEvent) {
      console.log("在IE浏览器");
      document.attachEvent("onmousewheel", this.scrollFun);
    } else {
      document.onmousewheel = this.scrollFun;
    }
  },
  // 操作方法
  methods: {
    textareaFocus() {
      this.height = 100;
    },
    textareaBlur() {
      this.height = 33;
    },
    // getUsers(){
    //       this.$source.get('/api/getusers').then(res=>{
    //         this.users = res.data.message
    //       })
    //     },

    logins() {
      // 不为空判断
      if (this.input1 !== "" && this.input1 !== undefined) {
        localStorage.setItem('oderNumber',this.input1)
        this.$router.push({
          name: "queryok",
          params: {
            input1: this.input1,
          },
        });
      } else if (this.input1 == "") {
        this.$message({
          message: "请输入正确内容进行查询",
          type: "warning",
        });
      }
    },

    scrollFun(event) {
      this.startTime = new Date().getTime();

      // mousewheel事件中的 “event.wheelDelta” 属性值：返回的如果是正值说明滚轮是向上滚动
      // DOMMouseScroll事件中的 “event.detail” 属性值：返回的如果是负值说明滚轮是向上滚动
      let delta = event.detail || -event.wheelDelta;
      // delta 为正则向下滚动,delta为负则向上滚动
      // 如果当前滚动开始时间和上次滚动结束时间的差值小于1.5s，则不执行翻页动作，这样做是为了实现类似节流的效果
      if (this.startTime - this.endTime > 1500) {
        if (
          delta > 0 &&
          parseInt(this.main.offsetTop) >=
            -(this.screenHeight * (this.pageNum - 2))
        ) {
          // 向下滚动
          this.index++;
          this.toPage(this.index);
        } else if (delta < 0 && parseInt(this.main.offsetTop) < 0) {
          // 向上滚动
          this.index--;
          this.toPage(this.index);
        }
        // 本次翻页结束，记录结束时间，用于下次判断
        this.endTime = new Date().getTime();
      }
    },
    // 翻页
    toPage(index) {
      if (index != this.curIndex) {
        let delta = index - this.curIndex;

        if (navigator.userAgent.toLowerCase().indexOf("firefox") != -1) {
          if (delta > 0) {
            this.nowTop =
              this.nowTop - (delta * this.screenHeight  );
          } else {
            this.nowTop =
              this.nowTop - (delta * this.screenHeight );
          }
        } else if (document.addEventListener) {
          console.log(delta);
          if (delta > 0) {
            this.nowTop =
              this.nowTop -
              (delta * this.screenHeight );
          } else {
            this.nowTop =
              this.nowTop -
              (delta * this.screenHeight );
          }
        } else if (document.attachEvent) {
          if (delta > 0) {
            this.nowTop =
              this.nowTop -
              (delta * this.screenHeight );
          } else {
            this.nowTop =
              this.nowTop -
              (delta * this.screenHeight );
          }
        } else {
          if (delta > 0) {
            this.nowTop =
              this.nowTop -
              (delta * this.screenHeight );
          } else {
            this.nowTop =
              this.nowTop -
              (delta * this.screenHeight);
          }
        }

        this.curIndex = index;
      }
    },
  },
};
</script>
<style   scoped>
.margin-top-l >>> .el-button--primary {
  font-size: 0.10416666666666667rem ;
  background-color: #fd9405;
  border-color: #fd9405;
}

.margin-top-l >>> .el-button--primary:hover {
  background-color: #fd9405;
  border-color: #fd9405;
}

.margin-top-l >>> .el-button--primary:focus {
  background-color: #fd9405;
  border-color: #fd9405;
}

textarea {
  resize: none;
  background: rgb(248, 248, 248);
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue